import logo from "app/assets/portal/logo-classtutor.png";
import { Button } from "app/components/v1/Button";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center text-center p-4" style={{ minHeight: "100vh" }}>
      <img src={logo} alt="ClassTutor" height={32} className="mb-4" />
      <h1 style={{ fontSize: 28 }}>That page is not here</h1>
      <p className="ct-muted">The link may be old, or the page has moved.</p>
      <Link to="/"><Button name="Go to Home" /></Link>
    </div>
  );
}
